import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1201dcfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 2,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AskusFilter = _resolveComponent("AskusFilter")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_AskusListContent = _resolveComponent("AskusListContent")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AskusFilter),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_vue_loading, {
            key: 0,
            loadingMessage: "Fragen werden geladen..."
          }))
        : (_openBlock(), _createBlock(_component_AskusListContent, {
            key: 1,
            questions: _ctx.questions,
            onOpenQuestion: _ctx.openQuestion
          }, null, 8, ["questions", "onOpenQuestion"])),
      (!_ctx.isLoading && _ctx.questions.length == 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Es sind noch keine Fragen vorhanden."))
        : _createCommentVNode("", true),
      (_ctx.pager.total_entries)
        ? (_openBlock(), _createBlock(_component_Paginator, {
            key: 3,
            rows: 10,
            totalRecords: _ctx.pager.total_entries,
            onPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPageChange($event)))
          }, null, 8, ["totalRecords"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}